import React from "react";
import { Route, Switch } from "react-router-dom";
import UploadFile from "./UploadFile";
import FileManagement from "./FileManagement/FileManagement";
import FileInfo from "./FileManagement/FileInfo";
import ReportList from "./Reports/ReportList";

const IRRBB = () => {
  return (
    <Switch>
      <Route exact path="/irrbb/upload" component={UploadFile} />
      <Route exact path="/irrbb/file-management" component={FileManagement} />
      <Route path="/irrbb/file-info/:date/:file_name" component={FileInfo} />
      <Route exact path="/irrbb/reports" component={ReportList} />
      <Route exact path="/irrbb" component={UploadFile} />
    </Switch>
  );
};

export default IRRBB;



// WEBPACK FOOTER //
// src/pages/IRRBB/index.js